@import '@client/theme/theme.less';

.header {
  box-shadow: 0 5px 10px @color-shadow;
  border-bottom: 1px solid @color-border;
}

.footer {
  border-top: 1px solid @color-border;
  text-align: center;
  background: @color-bg-elevated;
}
